// ProductInfo component goes in this file..
import React from 'react';

import '../../../assets/styles/product-styles/ProductInfo.scss';
// OR
// import '../../../assets/styles/product-styles/ProductInfo.css';

export default function ProductInfo() {
    return (
        <div>
            <h1>ProductInfo</h1>
        </div>
    )
}
